import { FormApiMethodsRequestData } from '../../../api/types/types';
import { Form } from '../../../types/types';
import {
  FormTokenNode,
  ResponseActionHandler,
} from '../../../types/context';
import useApiErrorHandling from '../../../hooks/useApiErrorHandling';
import { resolveFormApiMethod } from './resolveFormApiMethod';
import { submitWithForceRetry } from './submitWithForceRetry';

// Submits form data for edit (update-values) mode
export const submitEditForm = async (
  form: Form,
  requestBody: Record<string, unknown>,
  rowId: string,
  actualToken: FormTokenNode | null,
  sessionToken: string | null,
  update: (api: string, data: any) => Promise<any>,
  handleApiError: ReturnType<typeof useApiErrorHandling>,
  getResponseActionHandler?: (name: string) => ResponseActionHandler | undefined
) => {
  const resolvedMethod = resolveFormApiMethod(form.apiMethods, 'update-values');

  if (!resolvedMethod) {
    throw new Error('No method found');
  }

  // String apiMethod — update hook handles error internally
  if (typeof resolvedMethod === 'string') {
    return await update(`${resolvedMethod}/${rowId}`, requestBody);
  }

  // DetailedApiMethod flow with error handling and forceHeader retry
  const tokenRequestData = actualToken?.meta
    ?.requestData as FormApiMethodsRequestData;
  const submitRequestData: FormApiMethodsRequestData = {
    ...tokenRequestData,
    sessionId: sessionToken ?? '',
    // Override token's stale `id` (fixed to row-0 at form-open time) with the
    // actual current row — mirrors the same override in fetchEditRowData.
    id: rowId,
    form: requestBody,
  };

  return submitWithForceRetry(
    resolvedMethod,
    submitRequestData,
    handleApiError,
    getResponseActionHandler
  );
};
